module.exports = __webpack_public_path__ + "images/emoji/envelope.61c336da1178f433fdc3.png";